// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"mx","cardInnerHeading":"my","toggleWrapperClass":"mz","passwordProtection":"mA mz","textWrapperClass":"mB","toggleTextClass":"mC"};